import * as net from 'util/Net';

interface ConfirmMfaSetupResponse {
  success: boolean;
}

interface VerifyMfaCodeResponse {
  redirectUrl: string;
}

export function confirmMfaSetup(code: string): Promise<ConfirmMfaSetupResponse> {
  return net.postJSONPromise({url: '/settings/mfa', data: {code}});
}

export function verifyMfaCode(code: string): Promise<VerifyMfaCodeResponse> {
  return net.postJSONPromise({url: '/signin/verify-mfa', data: {code}});
}
